/**
 * uniqueValues
 * Returns an array containing unique values from the input array
 */
export function uniqueValues<T>(array: T[]): T[] {
    const uniqueArray: T[] = [];
    for (const item of array) {
        if (!uniqueArray.includes(item)) {
            uniqueArray.push(item);
        }
    }
    return uniqueArray;
}
